module.exports = __webpack_public_path__ + "static/media/BG.0dc4627f.png";